// extracted by mini-css-extract-plugin
module.exports = {"root":"mIndex_root__iJm2l","title":"mIndex_title__KIm0I","tag":"mIndex_tag__FiVvE","text":"mIndex_text__Khb6S"};